import React from "react";
var __jsx = React.createElement;
import { useScreenNavigation } from "@/common/Contexts/ScreenNavigationContext";
import { useSellCarData } from "@/common/Contexts/SellCarDataContext";
import { SELL_CAR_SCREENS } from "@/pages/sell-my-car/constants/screens";
import FlowOption from "@/pages/sell-my-car/components/FlowOption";
import FlowOptionBody from "@/pages/sell-my-car/components/FlowOptionBody";
import { useCallback, useState } from "react";
import { useTranslation } from "@i18n";
import FlowStepTitle from "@/pages/sell-my-car/components/FlowStepTitle";
import FlowSearchBar from "@/pages/sell-my-car/components/FlowSearchBar";
import FlowScreenHeaderSpacing from "@/pages/sell-my-car/components/FlowScreenHeaderSpacing";
import FlowScreenBodySpacing from "@/pages/sell-my-car/components/FlowScreenBodySpacing";
import { Conditional } from "@componentsShared/Conditional/Conditional";
import { Then } from "@componentsShared/Conditional/Then";
import { Else } from "@componentsShared/Conditional/Else";
import FlowZeroResult from "@/pages/sell-my-car/components/FlowZeroResult";
import useBoolean from "@hooks/useBoolean";
import { If } from "@componentsShared/Conditional/If";
import FlowOptionLoading from "@/pages/sell-my-car/components/FlowOptionLoading";
import { useLang } from "@/common/Contexts/LanguageContext";
var CarBrandScreen = function CarBrandScreen() {
  var _state$brandsData, _state$brandsData$mak, _state$brandsData2;
  var _useScreenNavigation = useScreenNavigation(),
    navActions = _useScreenNavigation.actions;
  var _useSellCarData = useSellCarData(),
    state = _useSellCarData.state,
    actions = _useSellCarData.actions;
  var _useState = useState(null),
    filteredMakes = _useState[0],
    setFilteredMakes = _useState[1];
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var _useState2 = useState(null),
    searchTerm = _useState2[0],
    setSearchTerm = _useState2[1];
  var loading = useBoolean(true);
  var lang = useLang();
  var handleMakeSelect = function handleMakeSelect(make) {
    actions.selectMake(make);
    navActions.navigateToScreen(SELL_CAR_SCREENS.CAR_MODEL);
  };
  var handleSearchResults = useCallback(function (results) {
    setFilteredMakes(results);
    loading.setFalse();
  }, []);
  var searchMakesWrapper = useCallback(function (_items, searchTerm, limit) {
    setSearchTerm(searchTerm);
    return actions.searchMakes(searchTerm, limit);
  }, [actions]);
  if (state.error) {
    return /*#__PURE__*/React.createElement("div", {
      className: "p-4"
    }, /*#__PURE__*/React.createElement("p", {
      className: "text-red-500"
    }, "Error loading brands: ", state.error.message));
  }
  return /*#__PURE__*/React.createElement("div", {
    id: "sell-car-brand-screen",
    className: "flex flex-col h-full md:pb-6"
  }, /*#__PURE__*/React.createElement(FlowScreenHeaderSpacing, null, /*#__PURE__*/React.createElement(FlowStepTitle, null, tShort("sell_trade_v2/choose_make", {
    ns: "web_sell_trade"
  })), /*#__PURE__*/React.createElement(If, {
    condition: ((_state$brandsData = state.brandsData) === null || _state$brandsData === void 0 ? void 0 : (_state$brandsData$mak = _state$brandsData.makes) === null || _state$brandsData$mak === void 0 ? void 0 : _state$brandsData$mak.length) > 8
  }, /*#__PURE__*/React.createElement(FlowSearchBar, {
    options: ((_state$brandsData2 = state.brandsData) === null || _state$brandsData2 === void 0 ? void 0 : _state$brandsData2.makes) || [],
    searchFunction: searchMakesWrapper,
    onSearch: handleSearchResults,
    onSelect: handleMakeSelect,
    limit: 200,
    getItemKey: function getItemKey(make) {
      return make.id;
    },
    placeholder: tShort("sell_trade_v2/search_brands_placeholder", {
      ns: "web_sell_trade"
    }),
    showResults: false,
    id: "brand-search"
  }))), /*#__PURE__*/React.createElement(FlowScreenBodySpacing, null, /*#__PURE__*/React.createElement(Conditional, {
    condition: (state === null || state === void 0 ? void 0 : state.isLoading) || loading.value
  }, /*#__PURE__*/React.createElement(Then, null, /*#__PURE__*/React.createElement(FlowOptionLoading, null)), /*#__PURE__*/React.createElement(Else, null, /*#__PURE__*/React.createElement(Conditional, {
    condition: (filteredMakes === null || filteredMakes === void 0 ? void 0 : filteredMakes.length) !== 0
  }, /*#__PURE__*/React.createElement(Then, null, /*#__PURE__*/React.createElement("div", {
    id: "sell-car-brand-list",
    className: "flex flex-col gap-3 md:grid md:grid-cols-6 md:gap-8",
    dir: lang == 'ar' ? "rtl" : "ltr"
  }, filteredMakes === null || filteredMakes === void 0 ? void 0 : filteredMakes.map(function (make) {
    return /*#__PURE__*/React.createElement(FlowOption, {
      key: make.id,
      id: "sell-car-brand-option-".concat(make.id),
      onClick: function onClick() {
        return handleMakeSelect(make);
      }
    }, /*#__PURE__*/React.createElement(FlowOptionBody, {
      name: lang == 'ar' ? make.name : make === null || make === void 0 ? void 0 : make.seo_url,
      imgUrl: make === null || make === void 0 ? void 0 : make.logo
    }));
  }))), /*#__PURE__*/React.createElement(Else, null, /*#__PURE__*/React.createElement(If, {
    condition: filteredMakes !== null && searchTerm !== null
  }, /*#__PURE__*/React.createElement(FlowZeroResult, {
    searchTerm: searchTerm
  }))))))));
};
export default CarBrandScreen;